import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';

// eslint-disable-next-line import/no-unresolved
import '@ssense/ui-component-library/lib/assets/css/material-dashboard-pro-react.css';
import './assets/stylesheets/bOnTimeCustomStyle.css';
import './assets/stylesheets/AvailabilityBox.css';

// eslint-disable-next-line react/jsx-filename-extension
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
